import { Inject } from "typescript-ioc";
import { Utils } from "Helpers/Scripts/Utils";
import { UiComponent } from "./UiComponent";
import { LoggerFactory } from "Logging/Scripts/LoggerFactory";
import { EventBinder } from "Events/Scripts/EventBinder";
import { UiComponentFactory } from "Ui/Scripts/UiComponentFactory";

export class Input extends UiComponent {
    constructor(
        @Inject componentFactory: UiComponentFactory,
        @Inject binder: EventBinder,
        @Inject loggerFactory: LoggerFactory
    ) {
        super(componentFactory, binder, loggerFactory);
    }

    /**
     * UI component's context element in the DOM.
     */
    public get context(): HTMLInputElement {
        return this.getContextAs(HTMLInputElement);
    }

    /**
     * @returns Name of the input element.
     */
    public getName() {
        return Utils.getAttr(this._context, "name");
    }

    /**
     * @returns Value of the context element.
     */
    public getValue(): any {
        return Utils.getValue(this._context);
    }

    /**
     * Sets a new value on the context element.
     * @param value Value to be set.
     */
    public setValue(value: string | number | string[]): this {
        Utils.setValue(this._context, value);
        return this;
    }

    /**
     * Binds change event handler. Multiple calls will bind multiple event handlers
     * which will be executed in the order they were added.
     * @param handler Event handler method reference.
     * @param namespace Optional event namespace used when binding this particular handler via jQuery.
     * @param one When true, the handler will be disconnected after first execution.
     */
    public bindChange(
        handler: (event?: JQuery.Event) => any,
        namespace?: string,
        one?: boolean
    ): this {
        this._binder.bindChange(handler, namespace, one);
        return this;
    }

    /**
     * Unbinds change event handler(s). When the handler reference is provided, this will
     * disconnect only the particular handler. When the namespace filter is provided,
     * only handlers previously connected with this namespace will be disconnected.
     * @param namespace Event namespace filter.
     * @param handler Event handler method reference.
     */
    public unbindChange(namespace?: string, handler?: (event?: JQuery.Event) => any): this {
        this._binder.unbindChange(namespace, handler);
        return this;
    }

    /**
     * Sets focus on the context element.
     */
    public focus(): this {
        this.context.focus();
        return this;
    }

    /*
     * Disable focus on the context element.
     */
    public blur(): this {
        this.context.blur();
        return this;
    }
}
